<template>
  <v-snackbar
    v-model="snackbarVisible"
    :timeout="-1"
    location="bottom"
    color="grey-darken-4"
    class="snack"
  >
    <div v-if="refreshingApp" class="d-flex align-center">
      <v-progress-circular indeterminate size="24" color="primary" />
      <span class="text-white pl-2">
        {{ $t('Caricamento nuovi contenuti...') }}
      </span>
    </div>

    <template v-else>
      <v-row no-gutters align="center">
        <v-col class="d-flex">
          {{ $t('Nuova versione!') }}
        </v-col>
        <v-col class="d-flex mr-2" style="max-width: 92px">
          <v-btn
            variant="text"
            class="text-black ml-0"
            color="yellow-accent-4"
            @click="emit('refresh')"
          >
            {{ $t('REFRESH') }}
          </v-btn>
        </v-col>
        <v-col class="d-flex" style="max-width: 36px">
          <v-btn
            icon
            variant="text"
            class="text-white mx-0 pr-0"
            @click="emit('skip')"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </template>
  </v-snackbar>
</template>

<script setup lang="ts">
/**
 * NewContentAvailableToastr
 *
 * @description PWA update notification snackbar.
 *              Shows when a new Service Worker is available.
 *              Migrated to <script setup> Composition API.
 */
import {computed} from 'vue'
import {useAppStore} from '@/stores/app'

defineOptions({ name: 'NewContentAvailableToastr' })

interface Props {
  refreshingApp?: boolean
}

withDefaults(defineProps<Props>(), {
  refreshingApp: false,
})

const emit = defineEmits<{
  refresh: []
  skip: []
}>()

const appStore = useAppStore()

const snackbarVisible = computed({
  get: () => appStore.newContentAvailable,
  set: () => {
    // Snackbar visibility is controlled by store
  },
})
</script>

<style lang="scss" scoped></style>
